//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { PaymentSurchargeUpdateItem } from './PaymentSurchargeUpdateItem';

export class SchoolPaymentSettingsUpdateItem extends ItemBase {
    CurrencyCode?: string | null;
    PaymentProcessorFeeCashCategoryID?: string | null;
    PaymentSurchargeACH?: PaymentSurchargeUpdateItem | null;
    PaymentSurchargeCreditCard?: PaymentSurchargeUpdateItem | null;
    SendAutomaticEmailReceipt?: boolean;
    SendAutomaticSMSReceipt?: boolean;
    ForceAutoPay?: boolean;
    PaymentSourceRequired?: boolean;

    constructor(initializer?: Partial<SchoolPaymentSettingsUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SchoolPaymentSettingsUpdateItem";
}
